<div class="content" [innerHTML]="receipt() | html: {sanitize: false}"></div>
